export const initialState = {
  login: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  loginInfo: {
    username: "",
    password: "",
  },
};
